export const ROUTE_PATH = {
  HOME: '/',
  LOGIN: '/login',

  ACCOUNT: '/users',
  ACCOUNT_CREATE: '/users/create',
  ACCOUNT_EDIT: '/users/:id/edit',

  ADMIN: '/users',
  ADMIN_CREATE: '/users/registration',
  ADMIN_EDIT: '/users/:id/edit',

  CLIENT: '/clients',
  CLIENT_CREATE: '/clients/registration',
  CLIENT_EDIT: '/clients/:id/edit',

  SALON_CREATE: '/clients/:clientId/salons/registration',
  SALON_EDIT: '/clients/:clientId/salons/:id/edit',

  NOTE: '/notes',
  NOTE_CREATE: '/notes/registration',
  NOTE_EDIT: '/notes/:id/edit',
  NOTE_ALLARTICLE: '/notes/allarticle',

  PROFILE: '/profile',

  SHADER: '/shader',
  SHADER_SETTING: '/shader/:materialId/setting',
  SOFA_SHADER: '/sofa',
  COLLECTION: '/collection',
  COLLECTION_DETAIL: '/collection/:id/detail',

  PLAN: '/plan',
  PLAN_CREATE: '/plan/create',
  PLAN_DETAIL: '/plan/:id',
  PLAN_EDIT: '/plan/:id/edit',
};
